import PageWrapper from "../components/Layout/PageWrapper";
import PasswordReset from "../components/user/PasswordReset";
import PasswordResetSuccess from "../components/user/PasswordResetSuccess";
import PasswordResetFailure from "../components/user/PasswordResetFailure";
import PasswordExpiredLink from "../components/user/PasswordExpiredLink";
import FailedEmailValidation from "../components/user/FailedEmailValidation";
import SuccessEmailValidation from "../components/user/SuccessEmailValidation";
import NotFound from "../components/user/NotFound";

export default {
  path: "/",
  component: PageWrapper,
  children: [
    {
      path: "/password/reset/:token",
      name: "PasswordReset",
      component: PasswordReset,
      beforeEnter: (to, from, next) => {
        next();
      }
    },
    {
      path: "reset-password/success",
      name: "PasswordResetSuccess",
      component: PasswordResetSuccess
    },
    {
      path: "reset-password/failed",
      name: "PasswordResetFailure",
      component: PasswordResetFailure
    },
    {
      path: "reset-password/expired",
      name: "PasswordExpiredLink",
      component: PasswordExpiredLink
    },
    {
      path: "email-validation/failed",
      name: "FailedEmailValidation",
      component: FailedEmailValidation
    },
    {
      path: "email-validation/success",
      name: "SuccessEmailValidation",
      component: SuccessEmailValidation
    },
    {
      path: "/404",
      name: "404",
      component: NotFound
    }
  ]
};
